/**
 * Centralized query keys for the time tracking domain.
 *
 * Single source of truth for both producers (`useTimeTracks`, `useSummary`)
 * and consumers (mutations that invalidate them) so an inline-string drift
 * between the two cannot silently break cache invalidation.
 */
export const TIME_TRACKING_QUERY_KEYS = Object.freeze({
  /** Prefix for all time-track list queries — use for invalidation. */
  timeTracksAll: ['time-tracks'] as const,
  /** Parameterized key matching `useTimeTracks`. */
  timeTracks: (startDate: string, endDate: string, projectId: number) =>
    ['time-tracks', startDate, endDate, projectId] as const,
  /** Prefix for all time-tracking summary queries — use for invalidation. */
  summaryAll: ['time-tracking-summary'] as const,
  /** Parameterized key matching `useSummary`. */
  summary: (startDate: string, endDate: string) =>
    ['time-tracking-summary', startDate, endDate] as const,
  /** Prefix for all week-overview queries. */
  weekOverviewAll: ['time-tracking-week-overview'] as const,
  weekOverview: (startDate: string, endDate: string) =>
    ['time-tracking-week-overview', startDate, endDate] as const,
  /** Prefix for all month-overview queries. */
  monthOverviewAll: ['time-tracking-month-overview'] as const,
  monthOverview: (startDate: string, endDate: string) =>
    ['time-tracking-month-overview', startDate, endDate] as const,
  /** Prefix for all day-overview queries. */
  dayOverviewAll: ['time-tracking-day-overview'] as const,
  dayOverview: (date: string) => ['time-tracking-day-overview', date] as const,
});
